import { requirePayPledges } from './pay-pledge-map';

const PAY_ROWS_ATTR = 'data-pay-rows';

export function rememberOpenPayRowIds(keys) {
    const rows = requirePayPledges(keys).map(function (pledge) {
        return { table_name: pledge.table_name, id: pledge.id };
    });
    $('#setPledgePaymentModal').attr(PAY_ROWS_ATTR, JSON.stringify(rows));
}

export function readOpenPayRowIds() {
    const raw = String($('#setPledgePaymentModal').attr(PAY_ROWS_ATTR) || '');
    if (raw === '') {
        return [];
    }
    try {
        const rows = JSON.parse(raw);
        return Array.isArray(rows) ? rows : [];
    } catch (err) {
        return [];
    }
}
